import { getLocalisedDateProperty } from '../utils/get-localised-date-property';
/**
 * Returns a numerical representation of the day of the week: 1, 2, ..., 7
 * @hidden
 */
export const getDayOfWeekNumeric = ({ offsetUtcDate }) => {
    const dayOfWeek = offsetUtcDate.getUTCDay();
    return dayOfWeek === 0 ? 7 : dayOfWeek;
};
/**
 * Returns a zero-indexed numerical representation of the day of the week: 0, 2, ..., 6
 * @hidden
 */
export const getDayOfWeekZeroIndexed = ({ offsetUtcDate }) => {
    return offsetUtcDate.getUTCDay();
};
/**
 * Returns an ordinal string representation of the day of the week: 0th, 2nd, ..., 6th
 * @hidden
 */
export const getDayOfWeekOrdinal = (params) => {
    const dayOfWeek = getDayOfWeekZeroIndexed(params);
    return params.ordinalStringFormatter(dayOfWeek);
};
/**
 * Returns a two-character localised string representation of the day of the week: Su, Mo, ..., Sa
 * @hidden
 */
export const getDayOfWeekTwoChar = (params) => {
    return getDayOfWeekShort(params).slice(0, 2);
};
/**
 * Returns a short localised string representation of the day of the week: Sun, Mon, ..., Sat
 * @hidden
 */
export const getDayOfWeekShort = (params) => {
    return getLocalisedDateProperty({
        date: params.date,
        languageTag: params.languageTag,
        ianaTimeZoneName: params.ianaTimeZoneName,
        property: 'weekday',
        format: 'short'
    });
};
/**
 * Returns a long localised string representation of the day of the week: Sunday, Monday, ..., Saturday
 * @hidden
 */
export const getDayOfWeekLong = (params) => {
    return getLocalisedDateProperty({
        date: params.date,
        languageTag: params.languageTag,
        ianaTimeZoneName: params.ianaTimeZoneName,
        property: 'weekday',
        format: 'long'
    });
};
//# sourceMappingURL=day-of-week.js.map